export default __webpack_public_path__ + "static/media/Group 93.cb2a5754.svg";